export default {
  firebase: {
    apiKey: "AIzaSyCohW3kltIzKI5ZOFyFeelGaGsZzV-c8tM",
    authDomain: "lawyerlyph-app.firebaseapp.com",
    projectId: "lawyerlyph-app",
    storageBucket: "lawyerlyph-app.appspot.com",
    messagingSenderId: "960303106597",
    appId: "1:960303106597:web:ae6697f6ba96fefdbe0dcc",
    measurementId: "G-GC3ZLG6PPZ"
  },

  api: {
    url: "https://lawyerly.ph/app/api/v2",
    domain: "https://lawyerly.ph/app"
  },

  subscription: {
    url: "/subscription"
  },

  io: {
    url: "https://lawyerly.ph/login?loginGoogle=1",
    exit: "https://lawyerly.ph"
  },


  plans:[
    {label: "1 Month", price: "500", type: 1},
    {label: "6 Months<br/>+ 1 Month Free", price: "3000", type: 2},
    {label: "10 Months <br/> + 2 Months Free", price: "5000", type: 3}
  ],

  mobile: false
};
